export default "__VITE_ASSET__DfhA9xEw__"